/**
 * Icône d'un outil — trait fin, jamais un aplat.
 *
 * Partagée par l'écran des outils et les tuiles : extraite de SpacePage quand les outils ont eu
 * leur propre écran, parce que deux copies auraient divergé au premier changement de trait.
 *
 * L'aplat de couleur reste réservé aux catégories : c'est ce qui distingue le contenu de
 * l'instrument. L'icône ne fait que donner une identité, d'où le trait de 1,5 et la taille
 * modeste. Elle prend la couleur d'accent quand l'outil a quelque chose à annoncer, l'encre
 * secondaire sinon — la même règle que le titre, pour que les deux disent la même chose.
 */
export function IconeOutil({
  nom,
  actif,
}: {
  nom: 'panier' | 'calendrier' | 'paquet' | 'image' | 'porte-monnaie'
  actif: boolean
}) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke={actif ? 'var(--color-accent)' : 'var(--color-ink-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="shrink-0"
    >
      {nom === 'panier' ? (
        <>
          <path d="M4 8h16l-1.4 9.3a2 2 0 0 1-2 1.7H7.4a2 2 0 0 1-2-1.7z" />
          <path d="M9 8V6a3 3 0 0 1 6 0v2" />
        </>
      ) : nom === 'calendrier' ? (
        <>
          <rect x="3.5" y="5" width="17" height="15" rx="2" />
          <path d="M3.5 10h17M8 3v4M16 3v4" />
        </>
      ) : nom === 'porte-monnaie' ? (
        <>
          <rect x="3" y="6.5" width="18" height="12" rx="2.5" />
          <path d="M3 10.5h12a2 2 0 0 1 0 4H3" />
          <circle cx="17.5" cy="12.5" r="0.9" fill="currentColor" stroke="none" />
        </>
      ) : nom === 'image' ? (
        <>
          <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
          <circle cx="9" cy="10" r="1.6" />
          <path d="m4 17 5-4.5 4 3.5 3-2.5 4 3.5" />
        </>
      ) : (
        <>
          <rect x="3.5" y="9" width="17" height="11" rx="1.5" />
          <path d="M3.5 13h17M12 9v11" />
          <path d="M12 9c-1.8 0-4-.6-4-2.4S9.4 4 12 9zM12 9c1.8 0 4-.6 4-2.4S14.6 4 12 9z" />
        </>
      )}
    </svg>
  )
}
